import EditPage from "../../components/EditPage";
import PageHeaderEdit from "../../components/PageHeaderEdit";
import PageInfoEdit from "../../components/PageInfoEdit";
import PageInfoWContactInfoEdit from "../../components/PageInfoWContactInfoEdit";
import GalleryEdit from "../../components/GalleryEdit";
import { UploadFolderIdProvider } from "../../util/UploadFolderIdContext";

export default function Andre() {
    const uploadFolderId = '13gHPsZzfoHdXjNWvnbXItg10WUoEkyIC';
    return (
        <UploadFolderIdProvider folderId={uploadFolderId}>
            <EditPage apiPath="page/Andre">
                <PageHeaderEdit sectionKey="PageHeader" />
                <PageInfoEdit sectionKey="Sec1" />
                <PageInfoWContactInfoEdit sectionKey="Sec2" />
                <GalleryEdit sectionKey={"Gallery"}/>
                <PageInfoWContactInfoEdit sectionKey="Sec3" />
                <PageInfoWContactInfoEdit sectionKey="Sec4" />
                <PageInfoWContactInfoEdit sectionKey="Sec5" />
                <PageInfoWContactInfoEdit sectionKey="Sec6" />
                <PageInfoWContactInfoEdit sectionKey="mandagsbedegruppe" />
                <PageInfoWContactInfoEdit sectionKey="u1" />
            </EditPage>
        </UploadFolderIdProvider>
    );
}